export function isClockwise(lib, path) {
    return lib.orientation(path);
}
//# sourceMappingURL=helpers.js.map